import { Button, Stack, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useMemo, useState } from 'react';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {
  createInpersonInterview,
  updateInpersonInterview,
} from 'src/services/candidate.service';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  boxDiv: {
    // padding: 20,
    gap: 16,
    // borderRadius: 6,
    // border: `1px solid ${theme.palette.border.primaryBlack3}`
  },
  btn: {
    width: '100%',
  },
}));

const FeedbackForm = ({
  jobId,
  userId,
  setFeedbackFormOpen,
  inpersonInterviewId,
}) => {
  const classes = useStyles();

  const defaultValues = useMemo(
    () => ({
      feedback: '',
    }),
    [],
  );

  const InpersonSchema = Yup.object().shape({
    feedback: Yup.string().required('Feedback is required'),
  });

  const ResumeMethods = useForm({
    resolver: yupResolver(InpersonSchema),
    defaultValues,
  });

  const [methods, setMethods] = useState(ResumeMethods);

  const { handleSubmit } = methods;

  const onSubmit = handleSubmit(async (data, event) => {
    console.log(data);
    const payload = {
      interview_feedback: data?.feedback,
      inperson_interview_id: inpersonInterviewId,
    };
    updateInpersonInterview(jobId, userId, payload)
      .then(res => {
        console.log(res);
        setFeedbackFormOpen([]);
      })
      .catch(err => {
        console.log(err);
      });
  });

  return (
    <Stack spacing="24px">
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack className={classes.boxDiv}>
          <Stack spacing="6px">
            <Typography variant="subtitle1">Feedback</Typography>
            <RHFTextField name="feedback" multiline rows={5} />
          </Stack>

          <Stack direction="row" spacing="12px">
            <Button
              variant="soft"
              size="large"
              width="100%"
              className={classes.btn}
              onClick={() => {
                setFeedbackFormOpen([]);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="large"
              type="submit"
              className={classes.btn}
            >
              Save
            </Button>
          </Stack>
        </Stack>
      </FormProvider>
    </Stack>
  );
};

export default FeedbackForm;

FeedbackForm.propTypes = {
  jobId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  setFeedbackFormOpen: PropTypes.func.isRequired,
  inpersonInterviewId: PropTypes.string.isRequired,
};
